'use strict';

class SpendingTypesController {
    /* @ngInject */
    constructor(
        SpendingTypesService,
        $scope,
        $q
    ) {
        Object.assign(this, {
            SpendingTypesService,
            $scope,
            $q
        });

        this.query = {
            include: [],
            where: {},
            limit: 25,
            page: 1,
            order: 'name DESC',
            deleted: true
        };

        this.getSpendingTypes();

        this.onPagination = () => {
            this.getSpendingTypes();
        };
    }

    getSpendingTypes() {
        let qOpts = JSON.parse(JSON.stringify(this.query));

        if (this.whereName) {
            let id = parseInt(this.whereName, 10);
            if (isNaN(id)) {
                Object.assign(qOpts.where, {
                    name : {
                        ilike: `%${this.whereName}%`
                    }
                });
            } else {
                Object.assign(qOpts.where, {
                    id: id
                });
            }
        }

        let queryReady = this.SpendingTypesService
            .getModels(qOpts)
            .then(spendingTypes => {
                this.spendingTypes = spendingTypes;
            });
        let countReady = this.SpendingTypesService
            .getCount(qOpts)
            .then(result => {
                this.spendingTypesCount = result.count;
            });
        this.promise = this.$q.all([queryReady, countReady]);
        return this.promise;
    }

}

export default SpendingTypesController;
